import { useHasCaptureAccess } from '~/hooks/account/usePlatformAccess';
import { audienceSubtypeEnabled } from '~/lib/audiences';
import {
  adsDestinationTypes,
  alertDestinationTypes,
  clearbitCaptureTypes,
  personalizationDestinationTypes,
} from '~/lib/destinations';

import { audienceSubTypesToShowAsDestinations } from './utils';

export default function useAvailableDestinationsLegacy(
  segmentType,
  account,
  showAlerting,
  showAdsProducts,
  showPersonalization,
) {
  const capture = useHasCaptureAccess();

  const adAudienceDestinations = audienceSubTypesToShowAsDestinations[
    segmentType
  ].filter((type) => audienceSubtypeEnabled(account?.plans, type));

  let destinations = [...adAudienceDestinations];

  if (capture) {
    destinations = destinations.concat(clearbitCaptureTypes(segmentType));
  }

  if (showAlerting) {
    destinations = destinations.concat(alertDestinationTypes());
  }

  if (showAdsProducts) {
    destinations = destinations.concat(adsDestinationTypes(segmentType));
  }

  if (showPersonalization) {
    destinations = destinations.concat(personalizationDestinationTypes());
  }

  return destinations;
}
